module.exports = __webpack_public_path__ + "static/media/Vaishnodevi_IdealHomes.294c1b50.pdf";